import Vue from 'vue'
//跟页面一样 ，同样的生命周期 和写法
//注意 如果页面data中有相同的 键名，会覆盖混入里面的  方法也是 有同名方法 也会覆盖混入里面的

//生命周期 如 created 会优先执行 混入里面的
let mixin = Vue.mixin({
	data() {
		return {}; //注意 如果页面data 中有相同的 键名，会优先使用 页面中的 
	},
	created() {

	},
	methods: {
		$msg(message, type = 'info') {
			this.$message({
				type,
				message
			});
		},
		$success(message) {
			this.$msg(message, 'success');
		},
		$warn(message) {
			this.$msg(message, 'warning');
		},
		$fail(message) {
			this.$msg(message, 'error');
		},
		$go(path) {
			// onComplete => {}, onAbort => {} 解决控制台 Uncaught (in promise) undefined
			this.$router.push(path, onComplete => {}, onAbort => {});
		},
		$replace(path) {
			// onComplete => {}, onAbort => {} 解决控制台 Uncaught (in promise) undefined
			this.$router.replace(path, onComplete => {}, onAbort => {});
		},
		/**
		 * 构造树型结构数据
		 * @param {*} data 数据源
		 * @param {*} id id字段 默认 'id'
		 * @param {*} parentId 父节点字段 默认 'parentId'
		 * @param {*} children 孩子节点字段 默认 'children'
		 * @param {*} rootId 根Id 默认 0
		 */
		$handleTree(data, id, parentId, children, rootId) {
			id = id || 'id'
			parentId = parentId || 'parentId'
			children = children || 'children'
			rootId = rootId || 0
			//对源数据深度克隆
			const cloneData = JSON.parse(JSON.stringify(data))
			//循环所有项
			const treeData = cloneData.filter(father => {
				let branchArr = cloneData.filter(child => {
					//返回每一项的子级数组
					return father[id] === child[parentId]
				});
				branchArr.length > 0 ? father.children = branchArr : '';
				//返回第一层
				return father[parentId] === rootId;
			});
			return treeData != '' ? treeData : data;
		}
	}
})
export default mixin
